import { useEffect, useState } from 'react';
import { get } from '../../Utilities';
import { connect } from 'react-redux';
import {
  getClientId,
  getClientUserId,
  getRoleArray,
} from '../../redux/reducers/clientUserId.reducer';
import { getUserProfile } from '../../redux/reducers/userProfile.reducer';
import AppointmentCard from './AppointmentCard';
import './RecentAppointments.scss';

const StudentAppointment = (props) => {
  const { clientId, clientUserId, userProfile, history } = props;
  const [upcoming, setUpcoming] = useState([]);
  //   const [completed, setCompleted] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    get({ client_id: clientId, client_user_id: clientUserId }, '/fetchUpcomingAndCompletedBookings')
      .then((res) => {
        if (res && res.success) {
          setUpcoming(res.result.upcoming || []);
          //   setCompleted(res.result.completed || []);
        }
      })
      .catch((error) => {
        console.error('Error fetching appointments:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [clientId, clientUserId]);

  const goToAllAppointments = () => {
    history.push('/all-appointments');
  };

  return (
    <div>
      {upcoming.length > 0 && (
        <div className='d-flex align-items-center justify-content-between mb-2'>
          <h4 className='fontBold mb-2'>My Bookings</h4>
          <button onClick={goToAllAppointments} className='viewAllButton'>
            View All
          </button>
        </div>
      )}
      <div className='d-flex align-items-center w-100'>
        {upcoming.map((appointment) => {
          return (
            <div key={appointment.appointment_order_id}>
              <AppointmentCard
                isDash
                key={appointment.appointment_order_id}
                appointment={appointment}
                clientId={clientId}
                clientUserId={clientUserId}
                userProfile={userProfile}
                isStudent
                history={history}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientUserId: getClientUserId(state),
  clientId: getClientId(state),
  roleArray: getRoleArray(state),
  userProfile: getUserProfile(state),
});

export default connect(mapStateToProps)(StudentAppointment);
